<style lang="scss" scoped>
.experience-title {
  height: 8.3vh;
  width: auto;
  margin-top: 1vh;
}
.banner {
  width: 96%;
  height: 33vh;
  margin-left: 2%;
  background: url('../../assets/mobile/experience-banner.png') center no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .bannner-item {
    height: auto;
    width: 92%;
    padding-left: 1%;
  }
}
.table-list {
  position: relative;
  width: 96%;
  height: 50vh;
  margin-left: 2%;
  background: url('../../assets/mobile/experience-content-bg.png') center no-repeat;
  background-size: 100% 100%;
  padding: 1.5vh 10% 0 13%;
  .switch-items {
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #bd4f67;
    overflow: hidden;
    .switch-item {
      position: relative;
      float: left;
      padding-left: 15px;
      padding-right: 15px;
      color: #952b4f;
      font-size: 18px;
      .choose-icon {
        width: 60px;
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
  }
  .ct-item {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border-bottom: 1px solid #bd4f67;
    margin-top: 10px;
    text-align: left;
    padding-left: 5px;
    font-size: 14px;
    .new-icon {
      float: left;
      height: 18px;
      margin-right: 15px;
      margin-top: 7px;
    }
    span {
      color: #bd4f67;
    }
  }
  .preview-page {
    width: 55px;
    position: absolute;
    bottom: 20px;
    left: 13%;
  }
  .next-page {
    width: 55px;
    position: absolute;
    bottom: 20px;
    right: 12%;
  }
}
.slide-fade-enter-active {
	transition: all 2s ease;
}
.slide-fade-enter {
  opacity: 0;
}
</style>

<template>
	<div class="m-experience mobile-common">
    <img class="experience-title" src="../../assets/mobile/experience-title.png" alt="experience-title">
    <div class="banner">
      <template v-for="(item, index) in bannerList" >
				<transition name="slide-fade" :key="item.wsId" >
					<img 
            v-show="index == numberChoose"
            @click="goUrl(item.wsUrl)" 
            class="bannner-item" 
            :src="item.wsImagePath" 
            :alt="item.wsImageName"
          >
				</transition>
			</template>
    </div>
    <div class="table-list">
      <div class="switch-items">
        <div 
          v-for="item in switchItemList" 
          :key="item.columnId" 
          @click="chooseItem(item.columnId)" 
          class="switch-item"
        >
          <span>{{item.columnName}}</span>
          <img v-show="postData.columnId == item.columnId" class="choose-icon" src="../../assets/pc/choosing.png" alt="">
        </div>
      </div>
      <div v-for="item in resultList" :key="item.newsId" class="ct-item">
        <router-link :to="{name: 'm-news-detail', params: {newsId: item.newsId}}">
          <img v-show="item.wasNew == '1'" class="new-icon" src="../../assets/pc/news.png" alt="">
          <span>{{item.newsTitle}}</span>
        </router-link>
      </div>
      <img @click="goPreview" class="preview-page" src="../../assets/pc/preview-page.png" alt="">
			<img @click="goNext" class="next-page" src="../../assets/pc/next-page.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name:'MExperience',
  data() {
    return {
      switchItemList: [],
			resultList: [],
			postData:{
				page: 1,
				pageSize: 5,
        columnId: '',
        platform: "2"
			},
      pageNumber: 1,
      timeInterval: null,
      bannerList: [],
      numberChoose: 0
    }
  },
  mounted() {
    const width = document.body.clientWidth;
		if(width > 850) {
			this.$router.push({name: 'p-experience'});
		} else {
			this.init();
		}
  },
  methods: {
    init() {
      // 获取栏目名称
			this.$http.get('/api/website/getColumn?platform=2').then((rsp) => {
        this.switchItemList = rsp.result.column;
        if(this.switchItemList.length > 0) {
          this.chooseItem(this.switchItemList[0].columnId);
        }
      });
      // 获取banner图
      this.$http.get('/api/website/getWorldStoryInfo?platform=2').then((rsp) => {
        this.bannerList = rsp.result.worldStory;
        this.interval();
			});
    },
    interval() {
			this.timeInterval = setInterval(() => {
				if(this.bannerList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.numberChoose == this.bannerList.length-1) {
						this.numberChoose = 0;
					} else {
						this.numberChoose ++;
					}
				}
			}, 8000);
    },
    clearInterval() {
			clearInterval(this.timeInterval);
		},
    chooseItem(id) {
			this.postData.page = 1;
			this.postData.columnId = id;
			this.getList();
    },
    getList() {
			this.$http.post('/api/website/getNewsList', this.postData).then((rsp) => {
				this.resultList = rsp.result.newsList.list;
				this.pageNumber = rsp.result.newsList.pages;
			});
    },
		goNext() {
			if(this.postData.page < this.pageNumber) {
				this.postData.page++;
				this.getList();
			} else {
				this.$Message.warning('没有更多了哦');
			}
		},
		goPreview() {
			if(this.postData.page != 1) {
				this.postData.page--;
				this.getList();
			} else {
				this.$Message.warning('没有上一页哦');
			}
		},
    goUrl(url) {
      window.open(url, '_blank');
    }
  },
  beforeDestroy() {
		this.clearInterval();
	}
}
</script>